/* Dirty South Tease — product page & quick shop.
   DST-051 server-resolved variants via option-value IDs + section rendering
   DST-052 fail closed on unavailable combinations (id cleared, every purchase path disabled)
   DST-053 atomic swaps, stale responses rejected (AbortController + request counter)
   DST-055 quantity rules · DST-056 duplicate-submit prevention · DST-057 Buy-it-now sync
   DST-058 sticky bar · DST-060 error recovery · DST-043 lightbox · DST-104 recently viewed */
(function () {
  'use strict';
  var DST = window.DST || {};
  if (DST.ProductUI) return;
  var cfg = DST.config || { strings: {} };
  var S = cfg.strings || {};

  function q(root, sel) { return root.querySelector(sel); }
  function qa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function announce(m, a) { if (DST.announce) DST.announce(m, a); }

  function ProductUI(root) {
    if (root.__dstProduct) return; root.__dstProduct = this;
    this.root = root;
    this.sectionId = root.getAttribute('data-section-id');
    this.url = root.getAttribute('data-product-url');
    this.reqCount = 0; this.ctrl = null; this.busy = false; this.resolving = false; this.lifecycle = new AbortController();
    this.bind();
    this.initGallery(); this.initLightbox(); this.initSticky(); this.initSizeChart(); this.initP13n();
    this.recordView();
    // Shopify injects the payment button after load; keep it in sync when it appears.
    var self = this;
    var mo = new MutationObserver(function () { if (q(root, '.shopify-payment-button button')) { mo.disconnect(); self.syncBuyNow(); } });
    mo.observe(root, { childList: true, subtree: true }); this.paymentObserver = mo;
    this.syncBuyNow();
  }

  ProductUI.prototype.form = function () { return q(this.root, 'form[data-product-form]'); };

  ProductUI.prototype.bind = function () {
    var self = this, root = this.root;
    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-value-id]')) self.resolve(e.target);
      if (e.target.matches('[data-qty-input]')) { self.validateQty(); self.syncBuyNow(); }
    }, { signal: this.lifecycle.signal });
    root.addEventListener('input', function (e) { if (e.target.matches('[data-qty-input]')) { self.validateQty(); self.syncBuyNow(); } }, { signal: this.lifecycle.signal });
    root.addEventListener('click', function (e) {
      var retry = e.target.closest('[data-variant-retry]');
      if (retry && root.contains(retry)) { e.preventDefault(); if (!self.resolving) self.resolve(); return; }
      var step = e.target.closest('[data-qty-step]');
      if (step && root.contains(step)) {
        var input = q(root, '[data-qty-input]'); if (!input) return;
        var inc = Number(input.getAttribute('data-step')) || 1, min = Number(input.getAttribute('data-min')) || 1;
        var v = (parseInt(input.value, 10) || min) + inc * Number(step.getAttribute('data-qty-step'));
        input.value = Math.max(min, v); self.validateQty(); self.syncBuyNow();
      }
    });
    // Submit lives on document so the sticky bar (form= attribute) shares the same handler.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('form[data-product-form]') || !root.contains(form)) return;
      self.submit(e);
    }, { capture: true, signal: this.lifecycle.signal });
  };

  /* ---------- Variant resolution ---------- */
  ProductUI.prototype.selected = function () {
    var groups = qa(this.root, '[data-option-group]');
    return groups.map(function (g) {
      var c = q(g, 'input:checked');
      return c ? { id: c.getAttribute('data-option-value-id'), name: c.value } : null;
    });
  };

  ProductUI.prototype.setPending = function (on) {
    var root = this.root; this.resolving = on;
    var retry = q(root, '[data-variant-retry]');
    if (retry) { retry.disabled = on; if (on) retry.hidden = true; }
    if (on) { var id = q(root, '[data-variant-input]'); if (id) { id.value = ''; id.setAttribute('data-disabled', ''); } }
    root.classList.toggle('is-resolving', on);
    qa(root, '[data-add-button], [data-sticky-add]').forEach(function (b) { if (on) { b.disabled = true; b.setAttribute('aria-busy', 'true'); } else b.removeAttribute('aria-busy'); });
    if (on) {
      var note = q(root, '[data-combo-note]'); if (note) note.hidden = true;
      this.syncBuyNow(false);
    }
  };

  ProductUI.prototype.resolve = function (changed) {
    var self = this, root = this.root;
    var sel = this.selected();
    if (sel.some(function (s) { return !s; })) { this.failClosed(S.unavailable || 'Choose options'); return; }
    var cur = changed && changed.closest('[data-option-group]');
    if (cur) { var lab = q(cur, '[data-option-current]'); if (lab) lab.textContent = changed.value; }
    var focusId = document.activeElement && root.contains(document.activeElement) ? document.activeElement.id : null;
    var my = ++this.reqCount;
    if (this.ctrl) this.ctrl.abort();
    this.ctrl = new AbortController();
    this.showError('');
    this.setPending(true);
    var u = new URL(this.url, window.location.origin);
    u.searchParams.set('option_values', sel.map(function (s) { return s.id; }).join(','));
    u.searchParams.set('section_id', this.sectionId);
    fetch(u.toString(), { signal: this.ctrl.signal, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        if (my !== self.reqCount) return; // stale response
        var doc = DST.parseHTML(html);
        var fresh = q(doc, '[data-product-section]');
        if (fresh && root.getAttribute('data-dom-prefix') && DST.namespaceProduct) DST.namespaceProduct(fresh, root.getAttribute('data-dom-prefix'));
        if (!fresh) throw new Error('No section');
        var data = null;
        try { data = JSON.parse(q(fresh, '[data-resolved-variant]').textContent); } catch (err) {}
        var names = sel.map(function (s) { return s.name; });
        var match = data && data.id && Array.isArray(data.options) && data.options.length === names.length &&
          data.options.every(function (o, i) { return String(o) === String(names[i]); });

        ['options', 'price', 'sku', 'inventory', 'quantity', 'sticky-price'].forEach(function (k) { self.swap(fresh, k); });
        if (match) {
          ['variant-id', 'buttons', 'sticky-button', 'share'].forEach(function (k) { self.swap(fresh, k); });
          self.setCombo(true);
          var shareBtn = q(root, '[data-share]'); if (shareBtn) shareBtn.setAttribute('data-url', window.location.origin + self.url + '?variant=' + data.id);
          if (data.featured_media) self.activateMedia(String(data.featured_media));
          if (window.history.replaceState && !root.closest('.dialog')) {
            var loc = new URL(window.location.href); loc.searchParams.set('variant', data.id); window.history.replaceState({}, '', loc.toString());
          }
          if (window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init) { try { Shopify.PaymentButton.init(); } catch (err) {} }
          var priceText = (q(root, '[data-swap="price"] .price__current') || {}).textContent || '';
          announce(names.join(', ') + '. ' + priceText.trim() + '. ' + (data.available ? 'In stock.' : (S.soldOut || 'Sold out') + '.'));
        } else {
          self.failClosed(S.unavailable || 'Unavailable');
          announce('That combination is not available. Choose a different option.', true);
        }
        self.setPending(false);
        self.applyState(match && data.available);
        if (focusId) { var f = document.getElementById(focusId); if (f) f.focus({ preventScroll: true }); }
        self.validateQty();
      })
      .catch(function (err) {
        if (err.name === 'AbortError') return;
        if (my !== self.reqCount) return;
        self.setPending(false);
        self.failClosed(undefined, false);
        self.showError('We couldn’t check that option. Your choices are kept. Retry your selection or choose another option.');
        var retry = q(root, '[data-variant-retry]'); if (retry) { retry.hidden = false; retry.disabled = false; }
        announce('We couldn’t check that option. Retry your selection or choose another option.', true);
      });
  };

  ProductUI.prototype.swap = function (fresh, key) {
    var a = q(this.root, '[data-swap="' + key + '"]'), b = q(fresh, '[data-swap="' + key + '"]');
    if (!a || !b) return;
    if (key === 'gallery-active') return;
    a.innerHTML = b.innerHTML;
    Array.prototype.slice.call(b.attributes).forEach(function (at) { if (at.name !== 'data-swap') a.setAttribute(at.name, at.value); });
    if (!b.hasAttribute('hidden')) a.removeAttribute('hidden');
    if (key === 'buttons') this.initSticky();
  };

  ProductUI.prototype.setCombo = function (ok, showUnavailable) {
    var note = q(this.root, '[data-combo-note]'); if (note) note.hidden = ok || showUnavailable === false;
    if (ok) this.showError('');
  };

  ProductUI.prototype.failClosed = function (label, showUnavailable) {
    var root = this.root;
    var id = q(root, '[data-variant-input]'); if (id) { id.value = ''; id.setAttribute('data-disabled', ''); }
    qa(root, '[data-add-button], [data-sticky-add]').forEach(function (b) {
      b.disabled = true;
      var l = q(b, '[data-add-label]') || b; if (label) l.textContent = label;
    });
    this.setCombo(false, showUnavailable);
    this.syncBuyNow(false);
  };

  ProductUI.prototype.applyState = function (purchasable) {
    var id = q(this.root, '[data-variant-input]');
    var ok = purchasable && !this.resolving && !this.busy && id && id.value && !id.hasAttribute('data-disabled');
    qa(this.root, '[data-add-button], [data-sticky-add]').forEach(function (b) { b.disabled = !ok; });
    this.syncBuyNow(ok);
  };

  ProductUI.prototype.syncBuyNow = function (force) {
    var id = q(this.root, '[data-variant-input]');
    var ok = force !== false && !this.resolving && !this.busy && !!(id && id.value && !id.hasAttribute('data-disabled')) && this.validateQty();
    qa(this.root, '[data-buy-now]').forEach(function (w) {
      w.hidden = !ok;
      qa(w, 'button').forEach(function (b) { b.disabled = !ok; });
    });
  };

  /* ---------- Quantity rules (DST-055) ---------- */
  ProductUI.prototype.validateQty = function () {
    var input = q(this.root, '[data-qty-input]'); if (!input) return true;
    var err = q(this.root, '[data-qty-error]');
    var raw = String(input.value).trim(), v = Number(raw);
    var min = Number(input.getAttribute('data-min')) || 1, step = Number(input.getAttribute('data-step')) || 1;
    var max = input.getAttribute('data-max') ? Number(input.getAttribute('data-max')) : null;
    var inCart = Number(input.getAttribute('data-in-cart')) || 0;
    var msg = '';
    if (raw === '' || !/^\d+$/.test(raw)) msg = 'Enter a whole number.';
    else if (v < min) msg = 'The minimum is ' + min + '.';
    else if (v % step !== 0) msg = 'This item is sold in multiples of ' + step + '.';
    else if (max !== null && v + inCart > max) msg = 'The maximum is ' + max + (inCart ? ' (you already have ' + inCart + ' in your bag)' : '') + '.';
    if (err) { err.textContent = msg; err.hidden = !msg; }
    input.setAttribute('aria-invalid', msg ? 'true' : 'false');
    return !msg;
  };

  /* ---------- Submit (DST-056 / DST-060) ---------- */
  ProductUI.prototype.showError = function (msg) {
    var el = q(this.root, '[data-form-error]'); if (!el) return;
    el.textContent = msg || ''; el.hidden = !msg;
    if (!msg) { var retry = q(this.root, '[data-variant-retry]'); if (retry) retry.hidden = true; }
  };

  ProductUI.prototype.submit = function (e) {
    var self = this, form = this.form();
    var id = q(this.root, '[data-variant-input]');
    var addBtn = q(this.root, '[data-add-button]');
    if (this.busy || this.resolving || this.root.classList.contains('is-resolving')) { e.preventDefault(); this.syncBuyNow(false); announce(this.resolving ? 'Please wait while we confirm your selection.' : 'Your item is being added.'); return; }
    if (!id || !id.value || id.hasAttribute('data-disabled') || (addBtn && addBtn.disabled)) {
      e.preventDefault(); announce('Choose an available option first.', true); return;
    }
    if (!this.validateQty()) { e.preventDefault(); var qi = q(this.root, '[data-qty-input]'); if (qi) qi.focus(); announce(q(this.root, '[data-qty-error]').textContent, true); return; }
    var bad = this.validateP13n();
    if (bad) { e.preventDefault(); bad.focus(); announce('Please complete the personalization details.', true); return; }
    this.showError('');
    var files = this.p13nFiles();
    if (files.length && form) form.enctype = 'multipart/form-data';
    if (cfg.cartType !== 'drawer') { this.lock(true); return; } // native POST /cart/add — lock prevents double submit
    e.preventDefault();
    if (files.length) { this.submitMultipart(form, addBtn); return; }
    var fd = new FormData(form), item = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity')) || 1 }, props = {};
    fd.forEach(function (val, key) { var m = key.match(/^properties\[(.+)\]$/); if (m && typeof val === 'string' && val !== '') props[m[1]] = val; });
    if (Object.keys(props).length) item.properties = props;
    if (fd.get('selling_plan')) item.selling_plan = Number(fd.get('selling_plan'));
    this.lock(true);
    announce(S.adding || 'Adding to bag…');
    DST.cart.add([item]).then(function () {
      var title = (q(self.root, '.product__title') || {}).textContent || 'Item';
      announce(title.trim() + ' ' + (S.added || 'added to your bag.'));
      var qi = q(self.root, '[data-qty-input]');
      if (qi) qi.setAttribute('data-in-cart', (Number(qi.getAttribute('data-in-cart')) || 0) + item.quantity);
      var dlg = self.root.closest('.dialog');
      if (dlg && DST.dialogs.QuickShop) DST.dialogs.QuickShop.close();
      if (self.root.hasAttribute('data-look-product-window')) self.root.dispatchEvent(new CustomEvent('dst:look-product-added', { bubbles: true }));
      else if (!DST.cart.open(addBtn)) window.location.href = (cfg.routes && cfg.routes.cart) || '/cart';
    }).catch(function (err) {
      // Never auto-retry: a timed-out POST may have succeeded. Refresh the bag so the shopper sees the truth.
      self.showError(err.message || S.cartError);
      announce(err.message || S.cartError, true);
      DST.cart.refresh();
    }).then(function () { self.lock(false); });
  };

  /* ---------- Personalization: uploads, text, instructions (v3.7.4) ---------- */
  var P13N_TYPES = /^(image\/(jpeg|png|webp|heic|heif)|application\/pdf)$/i;
  var P13N_EXT = /\.(jpe?g|png|webp|heic|heif|pdf)$/i;
  ProductUI.prototype.initP13n = function () {
    var self = this, root = this.root, box = q(root, '[data-p13n]'); if (!box) return;
    var maxBytes = (Number(box.getAttribute('data-max-mb')) || 10) * 1048576;
    function fieldError(input, msg) {
      var wrap = input.closest('.p13n__field'); var err = wrap && q(wrap, '[data-p13n-error]');
      if (err) { err.textContent = msg || ''; err.hidden = !msg; }
      if (msg) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid');
    }
    self.p13nFieldError = fieldError;
    function setPreview(input) {
      var wrap = input.closest('[data-p13n-upload]'), pv = q(wrap, '[data-p13n-preview]'), img = q(wrap, '[data-p13n-thumb]'), nm = q(wrap, '[data-p13n-name]');
      var f = input.files && input.files[0];
      if (img.src && img.src.indexOf('blob:') === 0) URL.revokeObjectURL(img.src);
      if (!f) { pv.hidden = true; img.removeAttribute('src'); wrap.classList.remove('has-file'); return; }
      nm.textContent = f.name + ' · ' + (f.size / 1048576).toFixed(1) + ' MB';
      if (/^image\/(jpeg|png|webp)$/i.test(f.type)) { img.src = URL.createObjectURL(f); img.hidden = false; } else { img.removeAttribute('src'); img.hidden = true; }
      pv.hidden = false; wrap.classList.add('has-file');
    }
    box.addEventListener('change', function (e) {
      var input = e.target; if (!input.matches('[data-p13n-file]')) return;
      var f = input.files && input.files[0];
      if (f && !(P13N_TYPES.test(f.type) || P13N_EXT.test(f.name))) { input.value = ''; fieldError(input, 'That file type isn’t supported. Use JPG, PNG, WEBP, HEIC or PDF.'); setPreview(input); return; }
      if (f && f.size > maxBytes) { input.value = ''; fieldError(input, 'That file is ' + (f.size / 1048576).toFixed(1) + ' MB. The limit is ' + (maxBytes / 1048576) + ' MB — try a smaller export.'); setPreview(input); return; }
      fieldError(input, ''); setPreview(input);
      if (f) announce('File attached: ' + f.name);
    }, { signal: this.lifecycle.signal });
    box.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-p13n-remove]'); if (!rm) return;
      var input = q(rm.closest('[data-p13n-upload]'), '[data-p13n-file]'); input.value = ''; setPreview(input); fieldError(input, ''); input.focus(); announce('File removed.');
    }, { signal: this.lifecycle.signal });
    box.addEventListener('input', function (e) {
      var t = e.target;
      if (t.matches('[data-p13n-count]')) { var c = q(t.closest('.p13n__field'), '[data-p13n-used]'); if (c) c.textContent = t.value.length; }
      if (t.matches('[data-p13n-required]') && t.getAttribute('aria-invalid') === 'true' && (t.type === 'checkbox' ? t.checked : t.value.trim())) fieldError(t, '');
    }, { signal: this.lifecycle.signal });
    box.addEventListener('change', function (e) { var t = e.target; if (t.type === 'checkbox' && t.checked) fieldError(t, ''); }, { signal: this.lifecycle.signal });
    ['dragenter', 'dragover'].forEach(function (ev) { box.addEventListener(ev, function (e) { var d = e.target.closest && e.target.closest('.p13n__drop'); if (d) d.classList.add('is-drag'); }, { signal: self.lifecycle.signal }); });
    ['dragleave', 'drop'].forEach(function (ev) { box.addEventListener(ev, function (e) { var d = e.target.closest && e.target.closest('.p13n__drop'); if (d) d.classList.remove('is-drag'); }, { signal: self.lifecycle.signal }); });
  };
  ProductUI.prototype.validateP13n = function () {
    var box = q(this.root, '[data-p13n]'); if (!box) return null;
    var first = null, self = this;
    qa(box, '[data-p13n-required]').forEach(function (el) {
      var ok = el.type === 'checkbox' ? el.checked : el.type === 'file' ? !!(el.files && el.files.length) : !!el.value.trim();
      var lab = (q(box, 'label[for="' + el.id + '"]') || {}).textContent || '';
      var msg = el.type === 'checkbox' ? 'Please confirm before adding to your bag.' : el.type === 'file' ? 'Please attach your file.' : 'Please fill in ' + lab.replace(/\(required\)/, '').trim().toLowerCase() + '.';
      if (self.p13nFieldError) self.p13nFieldError(el, ok ? '' : msg);
      if (!ok && !first) first = el;
    });
    return first;
  };
  ProductUI.prototype.p13nFiles = function () {
    var form = this.form(); if (!form) return [];
    return Array.prototype.slice.call(form.elements).filter(function (el) { return el.type === 'file' && el.files && el.files.length; });
  };
  ProductUI.prototype.submitMultipart = function (form, addBtn) {
    var self = this, fd = new FormData();
    Array.prototype.slice.call(form.elements).forEach(function (el) {
      if (!el.name || el.disabled) return;
      if (el.type === 'file') { if (el.files && el.files[0]) fd.append(el.name, el.files[0], el.files[0].name); return; }
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      if (el.tagName === 'BUTTON' || el.type === 'submit') return;
      if (/^properties\[/.test(el.name) && el.value === '') return;
      fd.append(el.name, el.value);
    });
    var qty = Number(fd.get('quantity')) || 1;
    this.lock(true);
    announce('Uploading your file and adding to bag…');
    if (addBtn) { var l = q(addBtn, '[data-add-label]'); if (l) { addBtn.__label = l.textContent; l.textContent = 'Uploading…'; } }
    DST.cart.addForm(fd)
      .then(function () {
        var title = (q(self.root, '.product__title') || {}).textContent || 'Item';
        announce(title.trim() + ' ' + (S.added || 'added to your bag.'));
        var qi = q(self.root, '[data-qty-input]'); if (qi) qi.setAttribute('data-in-cart', (Number(qi.getAttribute('data-in-cart')) || 0) + qty);
        if (self.root.hasAttribute('data-look-product-window')) self.root.dispatchEvent(new CustomEvent('dst:look-product-added', { bubbles: true }));
      else if (!DST.cart.open(addBtn)) window.location.href = (cfg.routes && cfg.routes.cart) || '/cart';
      })
      .catch(function (err) { self.showError(err.message || S.cartError); announce(err.message || S.cartError, true); DST.cart.refresh(); })
      .then(function () { if (addBtn && addBtn.__label) { var l2 = q(addBtn, '[data-add-label]'); if (l2) l2.textContent = addBtn.__label; } self.lock(false); });
  };

  ProductUI.prototype.lock = function (on) {
    this.busy = on; if (on) this.syncBuyNow(false);
    qa(this.root, '[data-add-button], [data-sticky-add]').forEach(function (b) {
      if (on) { b.setAttribute('aria-busy', 'true'); b.disabled = true; }
      else { b.removeAttribute('aria-busy'); }
    });
    if (!on) this.applyState(true);
  };

  /* ---------- Gallery ---------- */
  ProductUI.prototype.initGallery = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-thumb]');
      if (t && self.root.contains(t)) self.activateMedia(t.getAttribute('data-thumb'), true);
    });
  };
  ProductUI.prototype.activateMedia = function (mediaId, userInitiated) {
    var root = this.root, found = false;
    qa(root, '.product__slide').forEach(function (s) {
      var on = s.getAttribute('data-media-id') === String(mediaId);
      if (on) found = true;
    });
    if (!found) return;
    qa(root, '.product__slide').forEach(function (s) {
      var on = s.getAttribute('data-media-id') === String(mediaId);
      if (!on) { qa(s, 'video').forEach(function (v) { try { v.pause(); } catch (e) {} }); qa(s, 'iframe').forEach(function (f) { try { f.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*'); } catch (e) {} }); }
      s.hidden = !on; s.classList.toggle('is-active', on);
    });
    qa(root, '[data-thumb]').forEach(function (b) { b.setAttribute('aria-current', b.getAttribute('data-thumb') === String(mediaId) ? 'true' : 'false'); });
    if (userInitiated) announce('Showing media ' + (qa(root, '[data-thumb]').findIndex(function (b) { return b.getAttribute('data-thumb') === String(mediaId); }) + 1) + '.');
  };

  /* ---------- Lightbox (DST-043) ---------- */
  ProductUI.prototype.initLightbox = function () {
    var root = this.root, lb = q(root, '[data-lightbox]'); if (!lb) return;
    var items = qa(lb, '[data-lightbox-item]'), idx = 0, dlg = new DST.Dialog(lb), count = q(lb, '[data-lightbox-count]');
    function show(i) {
      idx = (i + items.length) % items.length;
      items.forEach(function (it, n) { it.hidden = n !== idx; it.classList.remove('is-zoomed'); });
      if (count) count.textContent = 'Image ' + (idx + 1) + ' of ' + items.length;
    }
    root.addEventListener('click', function (e) {
      var o = e.target.closest('[data-lightbox-open]');
      if (!o || !items.length) return;
      // map media index to image index
      var imgs = qa(root, '.product__slide[data-media-type="image"]'), slide = o.closest('.product__slide');
      show(Math.max(0, imgs.indexOf(slide))); dlg.open(o);
    });
    q(lb, '[data-lightbox-prev]').addEventListener('click', function () { show(idx - 1); });
    q(lb, '[data-lightbox-next]').addEventListener('click', function () { show(idx + 1); });
    lb.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') show(idx - 1); if (e.key === 'ArrowRight') show(idx + 1); });
    items.forEach(function (it) {
      var img = q(it, 'img');
      it.addEventListener('click', function (e) {
        if (it._dragged) { it._dragged = false; return; }
        var r = img.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        it.classList.toggle('is-zoomed');
      });
    });
    // swipe
    var sx = null;
    lb.addEventListener('pointerdown', function (e) { sx = e.clientX; });
    lb.addEventListener('pointerup', function (e) {
      if (sx === null) return; var dx = e.clientX - sx; sx = null;
      var cur = items[idx]; if (cur && cur.classList.contains('is-zoomed')) return;
      if (Math.abs(dx) > 50) { if (cur) cur._dragged = true; show(idx + (dx < 0 ? 1 : -1)); }
    });
    this.lightbox = dlg;
  };

  /* ---------- Sticky purchase bar (DST-058) ---------- */
  ProductUI.prototype.initSticky = function () {
    if (this.stickyObserver) { this.stickyObserver.disconnect(); this.stickyObserver = null; }
    var bar = q(this.root, '[data-sticky-buy]'), main = q(this.root, '[data-add-button]');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      bar.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
      document.documentElement.classList.toggle('has-sticky-buy', !bar.hidden);
    });
    io.observe(main); this.stickyObserver = io;
  };

  /* ---------- Size chart units (DST-044 / DST-167) ---------- */
  ProductUI.prototype.initSizeChart = function () {
    qa(document, '[data-sizechart]').forEach(function (chart) {
      if (chart.__init) return; chart.__init = true;
      var base = chart.getAttribute('data-unit') === 'cm' ? 'cm' : 'in';
      function render(unit) {
        qa(chart, '[data-measure]').forEach(function (td) {
          var raw = td.getAttribute('data-measure');
          if (unit === base) { td.textContent = raw; return; }
          td.textContent = raw.replace(/\d+(\.\d+)?/g, function (n) {
            var v = Number(n); v = base === 'in' ? v * 2.54 : v / 2.54;
            return (unit === 'cm' ? Math.round(v * 2) / 2 : Math.round(v * 100) / 100).toString();
          });
        });
        var note = q(chart, '[data-unit-note]');
        if (note) note.textContent = unit === 'cm' && base !== 'cm' ? 'Centimeters are approximate, rounded to the nearest 0.5 cm.' : (unit === 'in' && base !== 'in' ? 'Inches are converted and approximate.' : 'Original garment measurements in ' + (unit === 'cm' ? 'centimeters.' : 'inches.'));
        qa(chart, '[data-unit-btn]').forEach(function (b) {
          var on = b.getAttribute('data-unit-btn') === unit;
          b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.classList.toggle('button--outline', !on);
        });
      }
      chart.addEventListener('click', function (e) { var b = e.target.closest('[data-unit-btn]'); if (b) render(b.getAttribute('data-unit-btn')); });
      render(base);
    });
  };

  /* ---------- Recently viewed (DST-104): product handles only, never account/search data ---------- */
  ProductUI.prototype.recordView = function () {
    if (this.root.closest('.dialog')) return;
    var h = this.root.getAttribute('data-product-handle');
    if (h && DST.store) DST.store.push('dst_recent', h, 12);
  };

  ProductUI.prototype.destroy = function () {
    this.lifecycle.abort(); if (this.ctrl) this.ctrl.abort();
    if (this.paymentObserver) this.paymentObserver.disconnect();
    if (this.stickyObserver) this.stickyObserver.disconnect();
    if (this.lightbox) { this.lightbox.close(); clearTimeout(this.lightbox.hideTimer); }
    if (q(this.root, '[data-sticky-buy]')) document.documentElement.classList.remove('has-sticky-buy');
    Object.keys(DST.dialogs || {}).forEach(function (id) {
      var d = DST.dialogs[id];
      if (this.root.contains(d.el)) { d.close(); clearTimeout(d.hideTimer); delete DST.dialogs[id]; }
    }, this);
    this.reqCount++; this.root.__dstProduct = null;
  };

  function mountAll(scope) { ProductUI.prototype.initSizeChart(); qa(scope || document, '[data-product-section]').forEach(function (r) { new ProductUI(r); }); }
  document.addEventListener('shopify:section:load', function (e) { mountAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { qa(e.target, '[data-product-section]').forEach(function (r) { if (r.__dstProduct) r.__dstProduct.destroy(); }); });
  document.addEventListener('dst:product-form-mounted', function (e) { mountAll(e.detail && e.detail.root); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mountAll(); }); else mountAll();
  DST.ProductUI = ProductUI;
})();
